exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stepHeader__header___30r0r {\n  position: sticky;\n  position: -webkit-sticky;\n  width: 100%;\n  z-index: 3;\n  top: 0;\n  left: 0;\n  height: 54px;\n  display: flex;\n  background-color: white;\n  align-items: center;\n  flex-direction: row;\n  flex: 1 1 auto;\n  padding-left: 13px;\n  box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.1); }\n  @media (min-width: 576px) {\n    .stepHeader__header___30r0r {\n      display: none; } }\n\n.stepHeader__leftButton___1QWaf {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-right: 10px; }\n\n.stepHeader__rightButton___26nMe {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-right: 13px;\n  margin-left: 10px; }\n\n.stepHeader__title___GBlmd {\n  font-size: 18px;\n  font-weight: bold;\n  color: #292929;\n  display: flex;\n  width: 100%; }\n\n.stepHeader__logo___e0iAj {\n  display: block;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%); }\n", ""]);

// exports
exports.locals = {
	"header": "stepHeader__header___30r0r",
	"leftButton": "stepHeader__leftButton___1QWaf",
	"rightButton": "stepHeader__rightButton___26nMe",
	"title": "stepHeader__title___GBlmd",
	"logo": "stepHeader__logo___e0iAj"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdFormPage/StepHeader/stepHeader.scss
// module id = 4607
// module chunks = 6